import "./postInicio.css"
import { Link } from "react-router-dom";
import { Mail } from 'lucide-react';
import iconropamujer from "../../images/iconosinicio/ropamujer_main.png";
import iconropahombre from "../../images/iconosinicio/ropahombre_main.png";
import iconcalzado from "../../images/iconosinicio/calzado_main.png";
import iconropainterior from "../../images/iconosinicio/pijamas_main.png";
import iconbanador from "../../images/iconosinicio/bikini_main.png";
import iconbolso from "../../images/iconosinicio/bolso_main.png";

export default function PostInicio() {
    return (
        <div className="mainContainer">
            <div className="heroSection">
                <h1 className="mainTitle">Descubre Marcas de Ropa que Fabrican en España</h1>
                <p className="mainSubtitle">Explora una cuidada selección de las mejores marcas de moda hechas en España en diferentes categorías.</p>
            </div>

            <section className="categoriesSection">
                <h2 className="sectionTitle">Categorías</h2>
                <div className="categoriesGrid">
                    <Link to="/ropaMujer" className="categoryCard">
                        <div className="categoryImageContainer">
                            <img src={iconropamujer} alt="Ropa de Mujer" className="categoryImage" />
                        </div>
                        <h3 className="categoryTitle">Ropa de Mujer</h3>
                    </Link>

                    <Link to="/ropaHombre" className="categoryCard">
                        <div className="categoryImageContainer">
                            <img src={iconropahombre} alt="Ropa de Hombre" className="categoryImage" />
                        </div>
                        <h3 className="categoryTitle">Ropa de Hombre</h3>
                    </Link>

                    <Link to="/calzado" className="categoryCard">
                        <div className="categoryImageContainer">
                            <img src={iconcalzado} alt="Calzado" className="categoryImage" />
                        </div>
                        <h3 className="categoryTitle">Calzado</h3>
                    </Link>

                    <Link to="/ropainteriorypijamas" className="categoryCard">
                        <div className="categoryImageContainer">
                            <img src={iconropainterior} alt="Ropa Interior" className="categoryImage" />
                        </div>
                        <h3 className="categoryTitle">Ropa Interior y Pijamas</h3>
                    </Link>

                    <Link to="/banadoresybikinis" className="categoryCard">
                        <div className="categoryImageContainer">
                            <img src={iconbanador} alt="Bañadores" className="categoryImage" />
                        </div>
                        <h3 className="categoryTitle">Bañadores y Bikinis</h3>
                    </Link>

                    <Link to="/bolsosycomplementos" className="categoryCard">
                        <div className="categoryImageContainer">
                            <img src={iconbolso} alt="Bolsos y Complementos" className="categoryImage" />
                        </div>
                        <h3 className="categoryTitle">Bolsos y Complementos</h3>
                    </Link>
                </div>
            </section>

            <footer className="footer">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <div style={{ width: '30px' }}></div> {/* Empty div for spacing */}
                    <p style={{ textAlign: 'center', margin: '0 auto' }}>
                        Powered by{' '}
                        <a 
                            href="https://github.com/tu-usuario/tu-repositorio" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            © 2025
                        </a>
                    </p>
                    <a 
                        href="mailto:marcas_ropa_y_calzado@hotmail.com" 
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <Mail size={24} color="currentColor" />
                    </a>
                </div>
            </footer>
        </div>
    );
}